import React from "react";

import { Typography } from "@mui/joy";

import { ApiMessageTypes } from "../shared/interfaces";

import MarkdownMessage from "./MarkdownMessage";
import GenerateSpreadsheetMessage from "./GenerateSpreadsheetMessage";
import TableMessage from "./TableMessage";
import ErrorMessage from "./ErrorMessage";
import { MessageProps } from "../shared/props";

// Memoize each component
const MarkdownMessageMemo = React.memo(MarkdownMessage);
const GenerateSpreadsheetMessageMemo = React.memo(GenerateSpreadsheetMessage);
const TableMessageMemo = React.memo(TableMessage);
const ErrorMessageMemo = React.memo(ErrorMessage);

const messageComponents = {
    [ApiMessageTypes.Markdown]: MarkdownMessageMemo,
    [ApiMessageTypes.GenerateSpreadsheet]: GenerateSpreadsheetMessageMemo,
    [ApiMessageTypes.Table]: TableMessageMemo,
    [ApiMessageTypes.Error]: ErrorMessageMemo,
};

export default function Message(props: MessageProps) {
    const { message: msg, setCurrentFileViewerFile, currentFileViewerFile } = props;
    const MessageComponent = messageComponents[msg.messageType];

    if (MessageComponent) {
        return (
            <MessageComponent
                message={msg}
                key={msg.id}
                setCurrentFileViewerFile={setCurrentFileViewerFile}
                currentFileViewerFile={currentFileViewerFile}
            />
        );
    }

    return <Typography>Unknown message type {msg.messageType}</Typography>;
}
